import { render, staticRenderFns } from "./ServiceHall.vue?vue&type=template&id=9d194dac&"
import script from "./ServiceHall.vue?vue&type=script&lang=js&"
export * from "./ServiceHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports